import { BACKEND_URL } from '../utils/loadEnv'

export type AuthUser = {
    firstname: string
    lastname: string
    role: string
    image_url: string
}

export type LoginOk = {
    success: true
    message: string
    user: AuthUser
}

export type LoginErr = {
    success: false
    message: string
}

export async function login(username: string, password: string): Promise<LoginOk | LoginErr> {
    const resp = await fetch(`${BACKEND_URL}/authentication/authenticate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
    })

    return resp.json()
}

export async function me(): Promise<boolean> {
    const resp = await fetch(`${BACKEND_URL}/authentication/me`, {
        method: 'GET',
        credentials: 'include',
    })

    return resp.ok
}

export async function logout(): Promise<boolean> {
    const resp = await fetch(`${BACKEND_URL}/authentication/logout`, {
        method: 'POST',
        credentials: 'include',
    })

    return resp.ok
}